import { Form, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CODE_FISCALE_URL, MIOCODICEFISCALE_TOKEN } from "../../constants/app";

type CodeFiscaleInputProps = {
  name: string,
  label: string
};

const CodeFiscaleInput = ({
  name, label
}:CodeFiscaleInputProps) => {
  const { t } = useTranslation();
  const [isCodeValid, setIsCodeValid] = useState(false);

  return (
    <Form.Item
      name={name}
      label={label}
      required
      help={isCodeValid ? t("form.success.codFisc") : undefined}
      rules={[
        () => ({
          async validator(_, value) {
            if (value?.length === 16) {
              try {
                const response = await fetch(`${CODE_FISCALE_URL}/reverse?cf=${value}&access_token=${MIOCODICEFISCALE_TOKEN}`);
                const result = await response.json();
                if (result.status) {
                  setIsCodeValid(true);
                  return await Promise.resolve();
                }
              } catch (error) {
                setIsCodeValid(false);
                return Promise.reject(new Error(t("form.error.codFiscInvalid")));
              }
            }

            setIsCodeValid(false);
            return Promise.reject(new Error(t("form.error.codFiscInvalid")));
          },
        })]}
    >
      <Input
        maxLength={16}
      />
    </Form.Item>
  );
};

export default CodeFiscaleInput;
